export default __webpack_public_path__ + "static/pyxel-logo-white_3-47b7f3d98d64816c8636324b45f83f36.png";